import {
    getProductByValue,
    createProduct as create,
    getAllProducts,
    updateProduct as update,
    uploadProductImage, deleteProduct
} from '../../api/productFirebase';
import { sortAndFilterProducts } from '../../api/services/productService';

export const Types = {
    ADD: 'products/ADD',
    ERROR: 'products/ERROR',
    FILTER: 'products/FILTER',
    LOAD: 'products/LOAD',
    REMOVE: 'products/REMOVE',
    SEARCH: 'products/SEARCH',
    SEARCH_ALL: 'products/SEARCH_ALL',
    UPDATE: 'products/UPDATE',
    UPLOAD: 'products/UPLOAD'
}

const INITIAL_STATE = {
    type: null,
    data: null,
    loading: false,
    error: null,
};

export default function produtos(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.ADD: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        }
        case Types.FILTER: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.LOAD: {
            return { ...state, loading: true };
        }
        case Types.SEARCH: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.SEARCH_ALL: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.REMOVE: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.UPDATE: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.UPLOAD: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        default:
            return state;
    }
}

const createProduct = (data) => {
    return {
        type: Types.ADD,
        payload: data
    }
}

const errorProduct = (data) => {
    return {
        type: Types.ERROR,
        payload: data
    }
}

const getProductList = (data) => {
    return {
        type: Types.SEARCH_ALL,
        payload: data
    }
}

const getProduct = (data) => {
    return {
        type: Types.SEARCH,
        payload: data.result
    }
}

const loading = () => {
    return {
        type: Types.LOAD,
    };
}

const removeProduct = (data) => {
    return {
        type: Types.REMOVE,
        payload: data
    }
}

const updateProdut = (data) => {
    return {
        type: Types.UPDATE,
        payload: data
    }
}

const uploadProductImageForTheProduct = (data) => {
    return {
        type: Types.UPLOAD,
        payload: data
    }
}

export const Creators = {
    applyFiltering: (products, sortBy, isSearchBySegment) => {
        return (dispatch) => {
            dispatch(loading());
            dispatch(sortAndFilterProducts(products, sortBy, isSearchBySegment));
        }
    },
    createProduct: (product) => {
        return (dispatch) => {
            let upsert = ({Id, ...prod}) => create(prod)

            if (product.Id) {
                upsert = (prod) => update(prod.Id, prod)
            }

            upsert(product)
                .then((res) => {
                    dispatch(createProduct(res));
                })
                .catch((error) => {
                    dispatch(errorProduct(error))
                })
        };
    },
    deleteProduct: (key) => {
        return (dispatch) => {
            dispatch(loading());
            deleteProduct(key).then((data) => {
                dispatch(removeProduct(data))
            })
        }
    },
    getProduct: (name) => {
        return (dispatch) => {
            dispatch(loading());
            getProductByValue(name, (res) => {
                dispatch(getProduct(res));
            });
        };
    },
    getProductList: function () {
        return (dispatch) => {
            dispatch(loading());
            getAllProducts((res) => {
                dispatch(getProductList(res));
            });
        };
    },
    updateProduct: (value, product) => {
        const numberValue = parseInt(value);
        const prod = { ...product, estoque_atual: numberValue }

        return (dispatch) => {
            dispatch(loading());
            update(prod.Id, prod)
                .then((res) => {
                    dispatch(updateProdut(res));
                })
                .catch((error) => {
                    dispatch(errorProduct(error));
                })
        };
    },
    uploadImage: (file, fileName) => {
        return (dispatch) => {
            dispatch(loading());
            uploadProductImage(file, fileName, (res) => {
                dispatch(uploadProductImageForTheProduct(res));
            });
        };
    },
}
